import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { DropEvent } from '../../../shared/external-libraries/ng-drag-drop/shared/drop-event.model';
import { TooltipPosition } from '@angular/material/tooltip';

import { Workflow } from '../../../shared/models/site-content/workflow.model';

@Component({
    selector: 'app-permissions-preview-wf-hierarchy',
    templateUrl: './per-pre-wf-hierarchy.component.html',
    styleUrls: ['./per-pre-wf-hierarchy.component.scss'],
    standalone: false
})
export class PermissionsPreviewWfHierarchyComponent implements OnInit {
    // Inputs.
    @Input() siteWorkflows: Workflow[] = [];
    @Input() workflowsInHierarchy: Workflow[] = null; // These are initially specified workflows, if any.

    // Outputs.
    @Output() workflowHierarchyUpdated: EventEmitter<any> = new EventEmitter();

    // Properties.
    //private workflowsInHierarchy: Workflow[] = [];

    // Constructor.
    public constructor() {
        return;
    }

    // Life cycle methods.
    public ngOnInit(): void {
        /*
        if (this.siteWorkflows.length > 0) {
            let clonedWorkflow: Workflow = <Workflow>this.siteWorkflows[0].clone();
            this.workflowsInHierarchy.push(clonedWorkflow);
        }
        */

        return;
    }

    // Methods called by my HTML code.
    public get TooltipPosition(): TooltipPosition {
        let position: TooltipPosition = 'below';

        return (position);
    }

    public get AddWorkflowToHierarchyTooltip(): string {
        let tooltip: string = 'Drag this onto the canvas just below to add a workflow to the hierarchy';

        return (tooltip);
    }

    public get TrashTooltip(): string {
        let tooltip: string = 'Drag a workflow here to remove it from the hierarchy';

        return (tooltip);
    }

    public get SiteWorkflows(): Workflow[] {
        return (this.siteWorkflows);
    }

    public get WorkflowsInHierarchy(): Workflow[] {
        return (this.workflowsInHierarchy);
    }

    public get NoWorkflowsInHierarchy(): boolean {
        return (this.workflowsInHierarchy.length == 0);
    }

    // End methods called by my HTML code.

    // Control event handler methods.
    //Kevin
    public onWorkflowDroppedOnTrash(eventData: any): void {
        // Remove the workflow at the specified index.
        let iWorkflowToRemoveIndex: number = eventData.dragData;

        if (iWorkflowToRemoveIndex < this.workflowsInHierarchy.length) {
            this.workflowsInHierarchy.splice(iWorkflowToRemoveIndex, 1);

            this.outputWorkflowHierarchyUpdated();
        }

        return;
    }

    //Kevin
    public onWorkflowDroppedOnHierarchy(eventData: any, iAdjacentHierarchyElementIndex: number, bAfterElement: boolean): void {
        // For the time being, always insert the first site workflow.
        let workflowToAddToHierarchy: Workflow = this.siteWorkflows[0];
        let cloneToAddToHierarchy: Workflow = <Workflow>workflowToAddToHierarchy.clone();

        // Are we adding after the last element?
        if ((iAdjacentHierarchyElementIndex == this.workflowsInHierarchy.length - 1) && bAfterElement) {
            // Add a workflow after the last workflow in the hierarchy.
            this.workflowsInHierarchy.push(cloneToAddToHierarchy);
        } else {
            // Insert a workflow into the hierarchy.
            let iSplicePosition: number = iAdjacentHierarchyElementIndex;
            if (bAfterElement) {
                iSplicePosition++;
            }

            this.workflowsInHierarchy.splice(iSplicePosition, 0, cloneToAddToHierarchy);
        }

        this.outputWorkflowHierarchyUpdated();

        return;
    }

    public workflowSelectionChanged(iHierarchyIndex: number, eventData: MatSelectChange): void {
        // Find the selected site workflow.
        let arrSelectedWorkflow: Workflow[] = this.siteWorkflows.filter(wf => wf.id == eventData.value);

        if ((arrSelectedWorkflow != null) &&
            (arrSelectedWorkflow.length == 1) &&
            (iHierarchyIndex < this.workflowsInHierarchy.length)) {
            // Replace the hierarchy workflow with the newly selected one.
            let clonedWorkflow: Workflow = <Workflow>arrSelectedWorkflow[0].clone();
            this.workflowsInHierarchy.splice(iHierarchyIndex, 1, clonedWorkflow);

            this.outputWorkflowHierarchyUpdated();
        }

        return;
    }

    // End control event handler methods.

    // Private helper methods.
    private outputWorkflowHierarchyUpdated() {
        this.workflowHierarchyUpdated.emit(this.workflowsInHierarchy);

        return;
    }
}
